export default __webpack_public_path__ + "static/media/exam_overview_mobile.f21d1a6c.jpg";